import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
export const tableConfig = {
    selection: false,
    height: 357,
    columns: [
        {
            label: '变更单号',
            prop: 'customerChangeCode',
            type: 'slot',
            minWidth: 120
        },
        {
            label: '变更类型',
            prop: 'customerChangeType',
            type: 'select',
            optionsKey: 'CUSTOMER_CHANGE_TYPE',
            minWidth: 90
        },
        {
            label: '流程类型',
            prop: 'mipType',
            type: 'select',
            optionsKey: 'MIP_TYPE',
            minWidth: 90
        },
        {
            label: '审批状态',
            prop: 'mipStatus',
            type: 'select',
            optionsKey: 'RENEWAL_AUDIT_STATUS',
            minWidth: 80
        },
        {
            label: 'mip审批流编码',
            prop: 'mipId',
            minWidth: 160
        },
        {
            label: '创建人',
            prop: 'createUserCode',
            minWidth: 100
        },
        {
            label: '创建时间',
            prop: 'createTime',
            minWidth: 160
        },
        {
            label: '修改人',
            prop: 'updateUserCode',
            minWidth: 100
        },
        {
            label: '修改时间',
            prop: 'updateTime',
            minWidth: 160
        },
        {
            label: '审批流',
            prop: 'mipUrl',
            showTooltip: true,
            type: 'slot',
            minWidth: 300
        }
    ],
    actions: { // 表格操作列的配置
        fixedWidth: 80, // fixedWidth（可选） 设置操作列的固定宽度，不加该参数默认是按钮list长度*50px
        list: [
            {
                label: '删除',
                event: 'del',
                displayRule: (row) => {
                    const auth = otherUtils.getHasAuth(
                        btnAuthority.customerManage.iflowDetailDel
                    );
                    // 客户信息变更、客户状态变更、新增虚拟客户申请单 没有关联流程信息或者关联的流程信息的状态 = 草稿时
                    return auth && row.customerChangeType?.toString() !== '1' && ['', null, undefined, '1'].includes(row.mipStatus?.toString());
                }
            }
        ]
    }
};
